import refinementsDropdown from './components/refinements-dropdown';
import selectedRefinements from './components/selected-refinements';

/**
 * @param {Array<import('../../../type-definitions').Refinement>} refinements - refinement
 * @returns {boolean} whether all refinements have only one option
 */
const allRefinementsHaveOnlyOneOption = refinements => {
    return refinements.every(refinement => refinement.options.length === 1);
};

/**
 * @param {import('../../../type-definitions').SearchResult} result - Search result
 * @returns {string} refinements HTML
 */
export default result => {
    if (!result || !result.refinementsData || allRefinementsHaveOnlyOneOption(result.refinementsData.refinements)) {
        return '';
    }
    const {refinementsData, categories, numTotalResults, isCategorySearch, refinementURLBuilder, seoUrlConfig} = result;
    const noSelectedRefinementsClass = refinementsData.selectedRefinements.length === 0 ? 'no-refinements' : '';
    let showProductTextPlaceholder = window.Resources.SEARCH_NO_PRODUCTS_FOUND;
    if (numTotalResults === 1) {
        showProductTextPlaceholder = window.Resources.SEARCH_SHOW_PRODUCT.replace('{0}', numTotalResults);
    } else if (numTotalResults > 1) {
        showProductTextPlaceholder = window.Resources.SEARCH_SHOW_PRODUCTS.replace('{0}', numTotalResults);
    }
    const showProductText = showProductTextPlaceholder.replace('{0}', numTotalResults);

    const refinementsConfig = window.SitePreferences.REFINEMENT_CONFIGURATION;

    if (window.SitePreferences.HIDE_SEO_TEXT_ON_REFINEMENT) {
        const $bottomSeoContent = $('.js-bottom-category-seo');
        const $isConstructorRefinedSearch = $('.js-is-constructor-refined-search');
        if ($isConstructorRefinedSearch.length) {
            const SEOAssetID = $isConstructorRefinedSearch.data('seoAssetId');
            const data = {
                SEOAssetID
            };
            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: Urls.bottomCategorySeo,
                data,
                /**
                 * @param {string} response html response
                 */
                success(response) {
                    window.seoText = response;
                }
            });
        }
        if (!window.seoText) {
            window.seoText = $bottomSeoContent.html();
        }
        if (refinementsData.selectedRefinements.length !== 0) {
            $bottomSeoContent.empty();
        } else if (window.seoText) {
            $bottomSeoContent.html(window.seoText);
        }
    }

    return `
        <div id="refinements-filters" class="refinements-filters refinement-flyin ${noSelectedRefinementsClass} filters_2019">
            <div class="refinements" data-refconfig="${refinementsConfig || ''}">
                <div class="refinements-header">
                    <div class="refinements-title" tabindex="-1">${window.Resources.SEARCH_FILTERS}</div>
                    <button type="button" class="refinement-close js-refinements-toggle hide-on-desktop"
                        aria-label="${window.Resources.CLOSE}" data-toggle="refinements-active"
                        data-current-url="${refinementURLBuilder.getCurrentURL()}">
                        <span class="icon icon-icon-menu-close" aria-hidden="true"></span>
                    </button>
                </div>
                ${selectedRefinements(refinementsData.selectedRefinements, refinementURLBuilder, seoUrlConfig)}
                ${refinementsDropdown(
                    refinementsData.refinements,
                    categories,
                    isCategorySearch,
                    refinementURLBuilder,
                    seoUrlConfig
                )}
            </div>
        </div>
        <button id="refinements-apply" data-product-count="${numTotalResults}" class="refinements-apply hide-on-desktop js-refinements-toggle"
                data-="${window.Resources.SEARCH_SHOW_X_PRODUCTS.replace('{0}', numTotalResults)}"
                data-label-no-hits="${window.Resources.SEARCH_NO_PRODUCTS_FOUND}"
                data-toggle="refinements-active">
                <span class="refinements-apply-label" data-placeholder="${showProductTextPlaceholder}">
                    ${showProductText}
                </span>
            <span class="icon icon-arrow_right2" aria-hidden="true"></span>
        </button>
    `;
};
